import "./Gifts.css";
import React from "react";

const GiftsContainer = ({
  productList,
  setCurrentIndexes,
  currentIndexes,
  backgroundImageUrl = "",
}) => {
  const goToNext = (index) => {
    setCurrentIndexes((prevIndexes) =>
      prevIndexes.map((currentIndex, i) =>
        i === index
          ? (currentIndex + 1) % productList[index].imageUrls.length
          : currentIndex
      )
    );
  };

  const goToPrevious = (index) => {
    setCurrentIndexes((prevIndexes) =>
      prevIndexes.map((currentIndex, i) =>
        i === index
          ? (currentIndex - 1 + productList[index].imageUrls.length) %
            productList[index].imageUrls.length
          : currentIndex
      )
    );
  };

  const handleClick = (url) => {
    window.location.href = url;
  };

  return (
    <div
      className="grid-container"
      style={{
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      {productList.map((product, index) => (
        <div className="grid-item" key={product.id}>
          <div className="nested">
            <div className="carousel">
              {product.imageUrls.length > 1 && (
                <button
                  className="arrow left-arrow"
                  onClick={() => goToPrevious(index)}
                >
                  &#9664; {/* Left arrow */}
                </button>
              )}
              <div className="image-container">
                <img
                  src={product.imageUrls[currentIndexes[index]]}
                  alt={product.imageAlt}
                  loading="lazy"
                />
              </div>
              {product.imageUrls.length > 1 && (
                <button
                  className="arrow right-arrow"
                  onClick={() => goToNext(index)}
                >
                  &#9654; {/* Right arrow */}
                </button>
              )}
            </div>
            <div className="product-details">
              <p className="product-title">{product.title}</p>
              <p className="product-price">
                {product.price}
                {/* {"  "} */}
                {/* <span className="product-price-update"> */}
                {/* (Last updated: {product.priceLastUpdate}) */}
                {/* </span> */}
              </p>
              <button
                color="blue"
                style={{
                  color: "black",
                  backgroundColor: "#FF6F00",
                  fontWeight: "bold",
                  border: 0,
                  borderRadius: 5,
                  padding: 8,
                  margin: 4,
                  cursor: "pointer",
                }}
                onClick={() => handleClick(`${product.productUrl}`)}
              >
                Checkout more details on {product.seller}
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GiftsContainer;
